export default "__VITE_PUBLIC_ASSET__6e66a94d__"